// extracted by mini-css-extract-plugin
module.exports = {"castItem":"CastItem_castItem_2cEmD","wrapper":"CastItem_wrapper_4bign","name":"CastItem_name_2-0Iz","role":"CastItem_role_1u5-w","image":"CastItem_image_3hty6"};